import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const LoadingScreen = () => {
    return (
        <div className="container mx-auto h-screen flex flex-col items-center justify-center">
            <FontAwesomeIcon icon={faSpinner} spin size="3x" className="text-primary mb-10" />
            <div className="text-3xl text-primary">Een moment geduld alsjeblieft</div>
        </div>
    );
};
